import type { CSSProperties } from 'react';

export interface IIconProps {
    className?: string;
    style?: CSSProperties;
}

function IconChevronRight(props: IIconProps): JSX.Element {
    return (
        <svg
            style={props.style ?? {}}
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="chevron-right"
            className={`${props.className ?? ''} svg-inline--fa fa-chevron-right fa-w-10`}
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 80"
        >
            <polyline
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="10"
                stroke="currentColor"
                points="4,8 40,40 4,72"
            />
        </svg>
    );
}

export default IconChevronRight;
